<template>
  <el-main>
    <div class="tool" shadow="never">
      <CompositeQuery @query="query"></CompositeQuery>
    </div>
    <div class="table-wrapper">
      <el-table
        v-loading="loading"
        element-loading-text="正在查询...."
        element-loading-spinner="el-icon-loading"
        :data="queryResult"
        show-summary
        :summary-method="getSummaries"
        @row-dblclick="dblclickHandle"
        border
        style="width: 100%"
        height="100%"
        size="small"
      >
        <!-- 姓名 -->
        <el-table-column fixed prop="name" label="姓名" align="center"></el-table-column>
        <!-- 性别 -->
        <el-table-column fixed prop="sex" label="性别" align="center"></el-table-column>
        <!-- 出生日期 -->
        <el-table-column
          fixed
          prop="birthday"
          label="出生日期"
          align="center"
        ></el-table-column>
        <!-- 服务项目 -->
        <el-table-column
          fixed
          prop="itemname"
          label="服务项目"
          align="center"
        ></el-table-column>
        <!-- 服务次数 -->
        <el-table-column
          fixed
          prop="times"
          label="服务次数"
          align="center"
        ></el-table-column>
        <!-- 服务金额 -->
        <el-table-column
          fixed
          prop="amount"
          label="服务金额"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <!--  弹出框 ：老干部信息编辑，展示-->
    <el-dialog
      width="60%"
      v-if="dialogVisible"
      :fullscreen="true"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="handleClose"
    >
      <CadresInfoView
        :cadresid="cadresid"
        @edit-cancel="handleClose"
        @edit-finish="handleClose"
      ></CadresInfoView>
    </el-dialog>
  </el-main>
</template>

<script>
import CompositeQuery from "./CompositeQuery.vue";
import { CadresInfoView } from "@/components/CadresInfo";
export default {
  name: "CompositeSearch",
  components: { CompositeQuery, CadresInfoView },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      cadresid: null,
      cadresInfo: {},
      queryResult: [],
    };
  },
  methods: {
    query(compositeQuery) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$axios
        .post("/CompositeSearch/query", compositeQuery)
        .then((Response) => {
          const { data } = Response;
          this.queryResult = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 先计算数值列的总和,解决js小数位计算错误的问题，先将每一项*10，最后将总数除以10
      columns.forEach((column, index) => {
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] =
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr * 10;
              } else {
                return prev;
              }
            }, 0) / 10;
        } else {
          sums[index] = "";
        }
      });
      //总记录数
      let total = data.length || 0;
      //去重后的人数
      let num = [...new Set(data.map((item) => item.id))].length || 0;

      sums[0] = "统计信息:";
      sums[1] = "总记录数：" + total;
      sums[2] = "老干部人数：" + num;
      sums[3] = '';
      sums[4] = "服务次数：" + sums[4];
      sums[5] = "总金额：" + sums[5];

      return sums;
    },

    // 查看老干部信息
    dblclickHandle(row) {
      console.log(row);
      this.cadresid = row.id;
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },
    handleOk() {
      this.dialogVisible = false;
    },
  },
};
</script>
